<template>
	<v-wall :backImg='backImg'>
		<p slot='title'>新闻动态</p>
		<div class='news'>
			<ul>
				<li v-for='(newsList, index) in newsLists' :key="index">
					<div class='news-top'><p class='news-title'>{{newsList.title}}</p> <span class='news-line'></span> <span class="news-right">{{newsList.website}} {{newsList.date}}</span></div>
					<p class='news-content'>{{newsList.content | newListCut}} <span @click='goToUrl(newsList.url)'>点击查看>></span></p>
				</li>
			</ul>
		</div>
	</v-wall>
</template>

<script>
  import backImg from '../../assets/images/img_bg_02.jpg'
  export default {
    data () {
      return {
        newsLists: [{
          title: '“互联网+汽车金融”：技术革新助推汽车金融发展',
          content: '如今行业，越来越多消费者倾向于选择分期付款购车，但是传统汽车金融存在用户商业信用体系不健全、车贷审批慢且流程繁琐和部分用户贷款资料造假等问题，与消费者快速增长的需求较难匹配，汽车金融发展缓慢，模式升级成为重中之重。',
          date: '2016-12-28',
          website: '中国汽车网',
          url: 'http://www.chinacar.com.cn/newsview131053.html'
        }, {
          title: '科技创新“互联网+汽车金融”产晶',
          content: '经过与全国上千家大小车商细致调研后，充分了解现阶段分期业务突破点，拉丰科技迅速切入汽车金融市场，投入大量成本创新开发新产品——拉风车贷通。拉风车贷通以汽车分期审批货款为切入口，通过云计算、大数据技术，高效支持厂商的货款管理、风控审批、客户管理、流程审批等多个环节，极大缩短审批放款流程，提升用户消费体验，加快车商资金运转效率。',
          date: '2016-12-28',
          website: '搜狐汽车',
          url: 'http://shenzhen.auto.sohu.com/20161228/n477185454.shtml'
        }],
        backImg: backImg
      }
    },
    methods: {
      goToUrl (key) {
        window.open(key)
      }
    },
    filters: {
      newListCut (val) {
        val = val.length > 100 ? val.slice(0, 100) + '...' : val
        return val
      }
    }
  }
</script>

<style lang='scss' scoped>
	.news {
		padding: 80px 170px;
		text-align: left;
		width: 100%;
		li {
			margin: 30px 0;
		}
		.news-top {
			display: flex;
			display: -ms-flexbox;
			display: -webkit-flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 16px;
			position: relative;
			.news-title {
				font-size: 20px;
				color: #666666;
			}
			.news-right {
				font-size: 14px;
				color: #9B9B9B;
				line-height: 14px;
			}
			.news-line {
				flex: 1;
				height: 1px;
				background-color: #f0f0f0;
				margin: 0 16px;
			} 
		}
		.news-content {
			opacity: 0.8;
			font-size: 13px;
			color: #B3B3B3;
			letter-spacing: 0;
			line-height: 30px;
			height: 60px;
			white-space: wrap;
			text-overflow: ellipsis;
			overflow: hidden;
			span {
				color: #000;
				cursor: pointer;
				float: right;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// News.vue?4c5840a8